import React, { useState } from "react";
import clsx from "clsx";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Icon,
  Badge,
  Box,
  Fade,
  MenuItem,
  Menu,
} from "@material-ui/core";
import { AccountCircle, MoreVert } from "@material-ui/icons";
import { useNavigate } from "react-router";

import { useStyles } from "./HeaderStyles";
import { ReactComponent as MenuIcon } from "../../Assets/Svg/Header/menubar.svg";
import { ReactComponent as NotificationsIcon } from "../../Assets/Svg/Header/bellicon.svg";
import ProfileImage from "../../Assets/Images/profileIcon.jpg";
import AdminLogo from "../../Assets/Svg/Camroo_Horizontal_White.svg";
import ConfirmationModal from "Components/Modal/ConfirmationModal";

const menuId = "primary-search-account-menu";
const mobileMenuId = "primary-search-account-menu-mobile";

export default function Sidebar({
  // eslint-disable-next-line react/prop-types
  open,
  handleDrawerOpen,
  handleDrawerClose,
  headerText,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [, setNotificationAnchorEl] = useState(null);
  const [openLogoutConfirmation, setOpenLogoutConfirmation] = useState(false);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const classes = useStyles();
  const navigate = useNavigate();

  const handleClick = (event) => {
    setNotificationAnchorEl(event.currentTarget);
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = (from) => {
    setAnchorEl(null);
    if (from === "logout") {
      localStorage.removeItem("auth-token");
      navigate("/login");
    }
    handleMobileMenuClose();
  };

  const confirmLogout = () => {
    handleMenuClose("logout");
    setOpenLogoutConfirmation(false);
  };

  const renderMenu = (
    <Box className={classes.overFlowMenu}>
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transitioncomponent={Fade}
        className={classes.mobileMenu}
        keepMounted
        classes={{
          paper: classes.overFlowMenu1,
        }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        {isMenuOpen && (
          <Box className={classes.toolTip} transitioncomponent={Fade} />
        )}
        <MenuItem
          className={classes.menuItem}
          onClick={() => {
            handleMenuClose("profile");
            navigate("/admin/profile");
          }}
        >
          My Profile
        </MenuItem>
        <MenuItem
          className={classes.menuItem}
          // onClick={() => handleMenuClose("logout")}
          onClick={() => setOpenLogoutConfirmation(true)}
        >
          Logout
        </MenuItem>
      </Menu>
    </Box>
  );
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {/* <MenuItem>
        <IconButton aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={4} color="secondary">
            <Mail />
          </Badge>
        </IconButton>
        <p>Messages</p>
      </MenuItem>
      <MenuItem>
        <IconButton aria-label="show 11 new notifications" color="inherit">
          <Badge badgeContent={11} color="secondary">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <Notification notificationAnchorEl={notificationAnchorEl} handleClose={handleClose} /> */}
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  return (
    <>
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, classes.sectionDesktop, {
          [classes.appBarShift]: open,
        })}
      // title={<img src={LOGO} alt="noimage" />}
      >
        <Toolbar>
          <Box
            style={{
              marginRight: "50px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img src={AdminLogo} alt="Camroo" height={56} style={{ width: "auto", objectFit: "contain" }} />
          </Box>
          {!open && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={classes.primaryBtn}
            >
              <MenuIcon />
            </IconButton>
          )}
          {open && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerClose}
              edge="start"
              className={classes.primaryBtn}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Typography
            variant="h6"
            className={`${classes.sectionDesktop} ${classes.headerTitle}`}
            noWrap
          >
            {headerText}
          </Typography>
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            <IconButton
              className={`${classes.profileIcon} header-right-icon`}
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <Icon className={classes.iconImage}>
                <img alt="imageAlt" src={ProfileImage} />
              </Icon>
            </IconButton>
            {/* </Tooltip> */}
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="black"
            >
              <MoreVert color="black" />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, classes.sectionMobile, {
          [classes.appBarShift]: false,
        })}
      >
        <Toolbar>
          {!open && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              className={classes.primaryBtn}
            >
              <MenuIcon />
            </IconButton>
          )}
          {open && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              className={classes.primaryBtn}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Typography
            variant="h6"
            className={`${classes.sectionDesktop} ${classes.headerTitle}`}
            noWrap
          >
            {headerText}
          </Typography>
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            <IconButton
              aria-label="show 17 new notifications"
              onClick={handleClick}
              className="header-right-icon"
              color="inherit"
            >
              <Badge badgeContent={17} color="secondary">
                <NotificationsIcon />
              </Badge>
            </IconButton>
            <IconButton
              className="header-right-icon"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreVert />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
      {openLogoutConfirmation && (
        <ConfirmationModal
          handleClose={() => setOpenLogoutConfirmation(false)}
          open={openLogoutConfirmation}
          heading="Logout"
          subtitle={`Are you sure you want to logout?`}
          button1="Cancel"
          button2="Confirm"
          onButton1Click={() => setOpenLogoutConfirmation(false)}
          onButton2Click={confirmLogout}
        />
      )}
    </>
  );
}
